import { render } from "./Stories.vue?vue&type=template&id=4d23f220&scoped=true"
import script from "./Stories.vue?vue&type=script&lang=js"
export * from "./Stories.vue?vue&type=script&lang=js"

import "./Stories.vue?vue&type=style&index=0&id=4d23f220&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d23f220"

export default script